import React, { FC } from 'react';
import { Drawer as AntdDrawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';

export const Drawer: FC<DrawerProps> = (props) => {
  return <AntdDrawer {...props} />;
};

export default Drawer;
